import { buildJson } from "./payload.helper";

const talukaHelper = {
  forCreate: ({ district_id , name, status, permissions }) =>
    buildJson({
      district_id,
      name,
      status,
      permissions,
    }),

  forUpdate: (id, {district_id, name, status, permissions }) => ({
    id,
    body: buildJson({
      name,
      district_id,
      status,
      permissions,
    }),
  }),
};

export default talukaHelper;